export const organization = {
  routes: [
    {
      path: "/organization/asset-group/inventory",
      component: () => import("../organization-asset-group-category-asset-group-inventory-list-view"),
    },
    {
      path: "/organization/asset-group/criticality",
      component: () => import("../organization-asset-group-category-asset-group-criticality-view"),
    },
  ],
};
